import React from "react";
import { classNames } from "primereact/utils";

interface LinkItem {
  label: string;
  url: string;

  headerResources?: string;
  padding?: string;
}

interface ResourcesLinksProps {
  mainIcon: string;
  links: LinkItem[];
}

const ResourcesLinks: React.FC<ResourcesLinksProps> = ({ mainIcon, links }) => {
  return (
    <>
      <div className="flex align-items-center p-3 border-round ">
        <i className={classNames(mainIcon, "text-2xl")} />

        <ul className="flex gap-3 flex-column ">
          {links.map((link, resid) => (
            <div key={resid}>
              <div className="text-2xl text-left mb-2">{link.headerResources}</div>
              <li>
                <div className="flex align-items-baseline links-with-icon">
                  <a
                    key={resid}
                    href={link.url}
                    target="_blank"
                    title="Link opens in a new tab"
                    className={`links flex align-items-baseline text-primary  ${link.padding != undefined ? link.padding : ""}`}
                    rel="noreferrer">
                    {link.label}
                  </a>
                  <i className="pi pi-external-link ml-2 text-xl text-primary"></i>
                </div>
              </li>
            </div>
          ))}
        </ul>
      </div>
    </>
  );
};

export default ResourcesLinks;
